<template>
  <ionic-vue-page v-bind:title="screenTitle" v-bind:showRefresher="false">
    <error-message v-if="error" v-bind:message="error"></error-message>

    <ion-row class="ion-text-center">
      <ion-col size="12">
        <h4 class="h-f-b">I need help with...</h4>
      </ion-col>

      <ion-col
        v-for="(service, index) in services"
        v-bind:key="index"
        size="12"
      >
        <ion-button
          v-on:click="displayMessageComposer(service)"
          color="dark"
          expand="full"
          shape="round"
          >{{ service.name }}</ion-button
        >
      </ion-col>

      <ion-col size="12">
        <ion-button shape="round" fill="outline" v-on:click="displayMessenger()"
          >See all messages</ion-button
        >
        <p>Or visit the resources to find help.</p>
      </ion-col>
    </ion-row>
  </ionic-vue-page>
</template>

<script>
import intercomApiService from "../services/IntercomApi";
import firebase from "firebase";

export default {
  name: "Support",
  data() {
    return {
      screenTitle: "Support",
      services: {},
      error: false,
    };
  },
  mounted() {
    this.services = this.getServices();
  },
  methods: {
    async displayMessenger() {
      try {
        await intercomApiService.updateUser(
          firebase.auth().currentUser.displayName
        );
        await intercomApiService.displayMessenger();
      } catch (error) {
        this.error = error.message;
      }
    },

    async displayMessageComposer(service) {
      try {
        await intercomApiService.updateUser(
          firebase.auth().currentUser.displayName
        );
        await intercomApiService.displayMessageComposer(service.tag);
      } catch (error) {
        this.error = error.message;
      }
    },

    getServices() {
      return [
        {
          name: "My Payments",
          tag: "Payment",
        },
        {
          name: "Studio Enquiry",
          tag: "Studio Enquiry",
        },
        {
          name: "My Shifts",
          tag: "My Shifts",
        },
        {
          name: "Anything Else",
          tag: "",
        },
      ];
    },
  },
};
</script>
